import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

type StatusKey = 'open' | 'closed' | 'pending' | 'unassigned';

interface StatusConfig {
  label: string;
  icon: string;
  key: StatusKey;
}

const STATUS_MAP: Record<string, StatusConfig> = {
  OPEN:              { label: 'Aperta',               icon: 'fa-light fa-circle-play',  key: 'open' },
  CLOSED:            { label: 'Chiusa',                icon: 'fa-light fa-ban',           key: 'closed' },
  ASSIGNED_PENDING:  { label: 'Assegnazione Pendente', icon: 'fa-light fa-circle-pause', key: 'pending' },
  TO_ASSIGN:         { label: 'Da Assegnare',          icon: 'fa-light fa-circle-plus',  key: 'unassigned' },
};

@Component({
  selector: 'kc-conversation-status',
  imports: [NgClass],
  templateUrl: './conversation-status.component.html',
  styleUrl: './conversation-status.component.scss',
})
export class ConversationStatusComponent {
  @Input({ required: true }) status!: string;

  get config(): StatusConfig {
    return STATUS_MAP[this.status] ?? { label: this.status, icon: 'fa-light fa-circle', key: 'open' };
  }
}
